import CrudRepository from './CrudRepository'
export default class RecentPaymentsRepository extends CrudRepository {
  constructor () {
    super('core/api/users/recentPayments')
  }
}
